export class Accordeons {
  constructor() {
    this._accordeons = document.querySelectorAll('details');

    if (this._accordeons.length > 0) {
      this.init();
    }
  }

  init() {
    this._accordeons.forEach((accordeon) => {
      accordeon.addEventListener('click', (event) => {
        this._accordeons.forEach((accordeon) => {
          if (event.currentTarget === accordeon) return;
          accordeon.removeAttribute('open');
        })

        console.log(event.currentTarget);
        event.currentTarget.addAttribute('open', 'open');
      })
    })
  }
}
